
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import Store from "@/store/Store";
import { IMasterData, MasterData } from "@/store/MasterData";
import ButtonVue from "@/lib/Button.vue";
import FinderVue from "@/finder/Finder.vue";
import {
  IOpEtap,
  IOpOperacja,
  IOpParent,
  IOpEtapValidation,
  IOpEtapyValidations,
} from "../../server/src/tree/mapper/op/IOp";
import { OpController } from "../../server/src/tree/mapper/op/OpController";
import DbgVue from "../Dbg.vue";
import OpOperacjaVue from "./OpOperacja.vue";
import { OpSvc } from "./OpSvc";
import { IOpServer } from "server/src/tree/mapper/op/IOpServer";

import LblVue from "@/lbl/Lbl.vue";
import { ILbl } from "@/lbl/ILbl";

@Component({
  components: { FinderVue, ButtonVue, DbgVue, LblVue, OpOperacjaVue },
})
export default class OpOperacjeVue extends Vue {
  //@Prop(Array)  operacje!: IOpOperacja[];
  operacje!: IOpOperacja[];
  @Prop(String) tree_id: string | undefined;

  @Prop(Object) etapy_validations!: IOpEtapyValidations;
  @Prop(Number) etapy_validations_key!: number;
  @Prop(Object) parent: IOpParent | undefined;

  op_svc: IOpServer | undefined;

  md: IMasterData | undefined = undefined;
  oc = new OpController();
  key: number = 0;
  show_images: boolean = true;

  async mounted() {
    if (!this.parent) return;
    if (!this.tree_id) return;

    this.op_svc = new OpSvc(this.parent, this);
    this.operacje = await this.op_svc.get_operacje(this.tree_id);
    await this.oc.init(this.parent, this.operacje, this.op_svc);
    let counter=1
    for (let op of this.operacje) {
      if (!op.dbg) op.dbg={}
      if (op.color?.technologia) {
        op.dbg.lp = counter
        counter++
      }
    }
    this.md = await (await new Store().getStore()).masterData;
    if (!this.md) return;
    this.key++;
  }

  async add_new_etap(etap_typ: string) {
    let etap = this.oc.create_etap(etap_typ, "");
    await this.oc.add_new_etap(etap);
  }

  async lbl_changed(lbl:ILbl) {
    this.$emit("lbl_changed", lbl)
  }
}
